import { BaseControl } from './base';
import { formatDate } from '@shared/core/utils';
import { FieldValidators, FormFieldSerializedValue } from '../index';
import { unserializeDate } from './helpers';

export class DateControl extends BaseControl {
  unserializeValue(): any {
    return unserializeDate(this.field.value, this.options.dateFormat);
  }

  serializeValue(formControlValue: any): FormFieldSerializedValue {
    if (formControlValue == null) {
      return null;
    }

    return formatDate(formControlValue, this.options.dateFormat);
  }

  getValidatorConstraint(validatorName: keyof FieldValidators): any {
    if (!this.hasValidator(validatorName)) {
      return;
    }

    const validatorConstraint = super.getValidatorConstraint(validatorName);
    switch (validatorName) {
      case 'min':
      case 'max':
        return unserializeDate(validatorConstraint, this.options.dateFormat);
      default:
        return validatorConstraint;
    }
  }
}
